import { ERROR, LOAD_LINEUP, LOAD_LINEUP_CONFIG, RESET_LINEUP, STORE_PREV_LINEUP, SUCCESS_FETCH_ROI_DATA } from "../../types";
import { applySort, getFromStorage, updateStorage, getMatch, startHTTPRequest, getDefaultLbOptions, platformNameFormat, strategyNameFormat, formatFinalData, setRecommendedContestsData, deepClone, clearROICacheByMatchCode, fetchMatchCodeFromString } from "../../../assets/js/common";
import { CFG_IMAGE_GENERATOR_URL, CFG_RECOMMENDED_CONTEST_SETTINGS, FG_PRIMARY_PLATFORM, FG_PRIMARY_STRATEGY_ID } from "../../../assets/js/config";

const isMatchAsRoute = (slug, route) => {
    return slug === (route.params && route.params.slug);
};

const setRecommendedContestsDataMutation = (state) => {
    let {
        allDataOfTheMatch,
    } = state;

    let { strategies = [], entry_fee_from, entry_fee_to, contests_count } = CFG_RECOMMENDED_CONTEST_SETTINGS;
    let selectedStrategy = strategies.find((s) => s.id === state.lineup_selection.s_id);
    let { standing_position, spots_from, spots_to } = selectedStrategy;

    let entry_fee_filter = [
        { range: [entry_fee_from, entry_fee_to], is_selected: true }
    ];
    let initialStepValue = standing_position || state.initialStepValue;
    let filters = {
        price_pool: [0, 0],
        spots: [spots_from, spots_to],
        platforms: [state.lineup_selection.p_id],
        filter_applied: true,
        sort_by: {
            prop: "ar",
            order: "desc",
        },
    }

    let standingsData = formatFinalData(
        deepClone(allDataOfTheMatch)
    );
    let { contests, contests_total_count } = setRecommendedContestsData({
        standingsData,
        initialStepValue,
        filters,
        entry_fee_filter,
    });
    state.contest_count = contests_total_count;
    state.selectedMatchContests = contests.slice(0, contests_count);
    return state;
};

const team_store = {
    namespaced: true,
    state: () => ((typeof window !== "undefined" && window.__ROI_STATE_DATA__ && window.__ROI_STATE_DATA__.team_store) ? window.__ROI_STATE_DATA__.team_store :{
        page: 'team page',
        teams_store_filled: false,
        isLoading: true,
        match_data: [],
        match_api_version: null,
        slug: null,
        in_match_categories: [],
        current_category: null,
        can_update: false,
        contests_updated: false,
        no_matches_active: false,
        sort_lineup_order: [4, 1, 3, 2],
        lineup_selection: {
            p_id: null,
            s_id: null,
        },
        custom_team_base_sid: null,
        lineup_details: {
            tb: 0,
            ub: 0,
            team: [],
            bench: [],
            excluded: [],
            c_p: 0,
        },
        prev_lineup_details: {
            tb: 0,
            ub: 0,
            team: [],
            bench: [],
            excluded: [],
            c_p: 0,
        },
        locked_players: [],
        out_players: [],
        pf_dropdowns: [],
        stg_dropdown: {},
        selected_team: {
            id: null,
            index: null,
        },
        can_show_players_changed: false,
        can_show_undo: false,
        top_fantasy_xi_error: {
            status: false,
            msg: "",
        },
        is_polling: false,
        is_sharing: false,
        selectedMatchContests: [],
        allDataOfTheMatch: {},
        contest_loaded: false,
        contest_count: 0,
        can_recommended_update: true,
        contests_recommended_updated: false,
    }),
    actions: {
        slideChange: ({ rootState }, payload) => {
            let { match_detail_store } = rootState;
            match_detail_store.slug = payload.slug;

        },
        fetchLineup: ({ state, commit, rootState }, payload = {}) => {
            let { match_detail_store, translations } = rootState;
            let prev_playing_11 = [];
            if (state.lineup_details.team.length) {
                prev_playing_11 = state.lineup_details.team.map(
                    (player) => player.pid
                );
            }

            if (match_detail_store.no_matches_active) return;

            let match = getMatch(match_detail_store.match_data, "slug", match_detail_store.slug);
            let match_code = match.code;
            let updatedSN = {};
            if(match && match.code) {
                updatedSN[match.teams[0].code] = (match.teams[0].team_updated_short_name || match.teams[0].short_name);
                updatedSN[match.teams[0].id] = (match.teams[0].team_updated_short_name || match.teams[0].short_name);
                updatedSN[match.teams[1].code] = (match.teams[1].team_updated_short_name || match.teams[0].short_name);
                updatedSN[match.teams[1].id] = (match.teams[1].team_updated_short_name || match.teams[0].short_name);
            }
            /**
             * opt type 2 for player locking
             * opt type 1 for static team fetch by id
             */
            let params = {
                match_code: match_code,
                platform_guid: state.lineup_selection.p_id,
                p_strategy_id: state.lineup_selection.s_id,
                players_in_ids: state.locked_players.join(","),
                players_out_ids: state.out_players.join(","),
                option: 2,
            };
            if (!state.locked_players.length && !state.out_players.length) {
                params.players_in_ids = [];
                params.players_out_ids = [];
                params.option = 1;
                params.team_guid = state.selected_team.id;
            } else {
                params.p_strategy_id = state.custom_team_base_sid;
            }

            /**
             * in case of undo
             * store current in to prev
             * and load prev into current
             */
            if (payload && payload.is_undo) {
                let current_lineup = state.lineup_details;
                commit(LOAD_LINEUP, {
                    lineup_res: state.prev_lineup_details,
                    prev_playing_11,
                });
                commit(STORE_PREV_LINEUP, current_lineup);
                return;
            }

            commit(STORE_PREV_LINEUP);

            return startHTTPRequest({
                method: "GET",
                url: `api/Squad/TopFantasyXI`,
                params,
            })
                .then((res) => {
                    if (res.team) {
                        let { team, bench, excluded } = res;
                        team.forEach(tp => {
                            if(tp.tid && updatedSN && updatedSN[tp.tid]) {
                                tp.tsn = updatedSN[tp.tid];
                            }
                        })
                        bench.forEach(bp => {
                            if(bp.tid && updatedSN && updatedSN[bp.tid]) {
                                bp.tsn = updatedSN[bp.tid];
                            }
                        })
                        excluded.forEach(ep => {
                            if(ep.tid && updatedSN && updatedSN[ep.tid]) {
                                ep.tsn = updatedSN[ep.tid];
                            }
                        })
                        return commit(LOAD_LINEUP, {
                            lineup_res: res,
                            prev_playing_11,
                        });
                    } else {
                        state.top_fantasy_xi_error.status = true;
                        state.top_fantasy_xi_error.msg = translations.lineup_errors[res.status];

                    }
                })
                .catch((e) => {
                    state.top_fantasy_xi_error.status = true;
                    state.top_fantasy_xi_error.msg = translations.lineup_errors[0];
                    console.log(e);
                    console.log(e.toString());
                });
        },
        fetchLineupConfig: ({ state, commit, rootState, dispatch }) => {
            let { match_detail_store, route } = rootState;
            if (match_detail_store.no_matches_active) return;

            let is_same = isMatchAsRoute(match_detail_store.slug, route);

            let match = getMatch(match_detail_store.match_data, "slug", match_detail_store.slug);

            let toSend = {
                match_code: match.code,
                v: 2,
            };

            if (match.ls === 1 && match.lineups_generated === 2) {
                toSend.buster = match.code;
                toSend.toss_status = 1;
            }

            return startHTTPRequest({
                method: "GET",
                url: `api/squad/getFantasyMatchLineDetails`,
                params: toSend,
            })
                .then((res) => {
                    state.lineup_selection = {
                        p_id: null,
                        s_id: null,
                    };
                    state.teams_store_filled = true;
                    if (res.platforms) {
                        if (route.params && route.params.lb_options) {
                            let optionsFromUrl = getDefaultLbOptions(route.params.lb_options);
                            let platform = res.platforms.find(p => (platformNameFormat(p.pname) === optionsFromUrl.pf));
                            let strategy = platform && platform.strategy.find(s => (strategyNameFormat(s.ssn) === optionsFromUrl.st));

                            state.lineup_selection.p_id = platform ? platform.pid : null;
                            state.lineup_selection.s_id = strategy ? +strategy.sid : null;
                        } else if (
                            route.query &&
                            route.query.platform &&
                            route.query.strategy &&
                            +route.query.strategy !== 0 &&
                            is_same
                        ) {
                            state.lineup_selection.p_id = route.query.platform;
                            state.lineup_selection.s_id = +route.query.strategy;
                        } else {
                            let platform = res.platforms.find(p => p.pname.toLowerCase() == FG_PRIMARY_PLATFORM);
                            if(platform && platform.pid) {
                                let strategy = platform.strategy.find(s => s.sid == FG_PRIMARY_STRATEGY_ID);
                                state.lineup_selection.p_id = platform.pid;
                                state.lineup_selection.s_id = strategy ? +strategy.sid : null;
                            }
                        }

                        commit(LOAD_LINEUP_CONFIG, res);

                        return Promise.all([
                            dispatch("fetchRecommendedContests", {
                                slug: match_detail_store.slug,
                            }),
                            dispatch("fetchLineup")
                        ])
                    }
                })
                .catch((e) => {
                    state.teams_store_filled = true;
                    console.log(e);
                    console.log(e.toString());
                });
        },
        resetLineup: ({ commit }) => {
            return commit(RESET_LINEUP);
        },
        matchDataUpdatePolling: ({ dispatch, rootState }) => {
            let { match_detail_store } = rootState;
            let params = {}, oldLineupStatus = false;
            if(match_detail_store && match_detail_store.match_data && match_detail_store.slug) {
                params["matchcode"] = fetchMatchCodeFromString(match_detail_store.slug);
                let currMatch = getMatch(match_detail_store.match_data, "slug", match_detail_store.slug);
                oldLineupStatus = (currMatch.ls === 1 && currMatch.lineups_generated === 2);
            }
            return startHTTPRequest({
                method: "GET",
                url: `api/App/GetMatches`,
                params
            })
                .then((res) => {
                    let { matches, categories } = res;
                    matches = matches.filter(m => m.show_in_fe);
                    categories = categories.filter(c => {
                        let hasMatchAvailable = matches.find(m => (m.category_id == c.category_id && m.show_in_fe))
                        return hasMatchAvailable;
                    })
                    dispatch("match_detail_store/updateRootMatchData", { ...res, matches: matches, categories: categories}, { root: true });

                    let current_match = getMatch(matches, "slug", match_detail_store.slug);

                    if (
                        !oldLineupStatus &&
                        current_match &&
                        current_match.ls === 1 &&
                        current_match.lineups_generated === 2
                    ) {
                        /* if lineup status updated then fetchLineupConfig will call fetchLineup & fetchRecommendedContests actions */
                        dispatch("fetchLineupConfig");
                    } else {
                        /* if lineup status not updated then check version for and call fetchRecommendedContests action */
                    }


                });
        },
        shareLineup: ({ state }, toSend) => {
            return window.fetch(CFG_IMAGE_GENERATOR_URL, {
                method: "POST",
                mode: "no-cors",
                headers: {
                    "content-type": "application/json",
                    "accept": "application/json",
                },
                body: JSON.stringify(toSend),
            });
        },
        fetchRecommendedContests: ({ commit, state, rootState, dispatch }, { slug }) => {
            let { match_detail_store, route } = rootState;
            if (match_detail_store.no_matches_active) return;

            let level = route.query && route.query.level;

            let match = getMatch(match_detail_store.match_data, "slug", slug);
            let match_code = match.code;
            let match_guid = match.id;

            dispatch(
                "match_detail_store/updateMatchState",
                { code: match_code, match_loaded: typeof match_detail_store.is_initial_request === "undefined", /* first time no shimmer; ssr->frotend first call */ },
                { root: true }
            );

            /**
             * on client side initial ROI data fetch is requested by
             * route change event and front end check auth flow
             * so using `is_initial_request` as decider
             * on ssr is_initial_request is undefined
             * after first request is_initial_request is number cuz of route change call
             * and here for second time chekcing if number and making boolean after authflow call
             * currently boolean part not in use
             */

            //after first request done form frontend , fill in the value
            typeof window !== "undefined" && (match_detail_store.is_initial_request = Date.now());

            if (getFromStorage(`roi:${match.version}:${match.code}`)) {
                dispatch(
                    "match_detail_store/updateMatchState",
                    { code: match_code, match_loaded: true },
                    { root: true }
                );
                let data = JSON.parse(
                    getFromStorage(`roi:${match.version}:${match.code}`)
                );
                data.level = level;
                commit(SUCCESS_FETCH_ROI_DATA, data);
                return;
            }

            return startHTTPRequest({
                method: "GET",
                url: `api/App/ContestROI`,
                params: {
                    match_code: match_guid,
                },
            })
                .then((res) => {
                    if (res) {
                        let data = deepClone(res);
                        data.level = level;
                        commit(SUCCESS_FETCH_ROI_DATA, data);
                        dispatch(
                            "match_detail_store/updateMatchState",
                            { code: match_code, match_loaded: true },
                            { root: true }
                        );
                        if (typeof window !== "undefined") {
                            clearROICacheByMatchCode({ code: match.code });
                            updateStorage(`roi:${match.version}:${match.code}`, JSON.stringify(res));
                        }
                    } else {
                        state.contest_loaded = true;
                        console.log("API ERROR---->");
                        commit(ERROR);
                    }
                })
                .catch((e) => {
                    state.contest_loaded = true;
                    console.log(e);
                });
        },
    },
    mutations: {
        [ERROR]: (state) => {
            return (state.isLoading = false);
        },
        [LOAD_LINEUP]: (state, payload) => {
            let {
                lineup_res: { team, bench, excluded, ub, tb },
                prev_playing_11,
            } = payload;
            let to_save = {
                tb: 0,
                ub: 0,
                team: [],
                bench: [],
                excluded: [],
                c_p: 0,
            };

            let grade_to_pts = {
                "A+": 5,
                A: 4,
                B: 3,
                C: 2,
                D: 1,
            };

            let ordered_list = {
                team: {
                    4: [],
                    2: [],
                    3: [],
                    1: [],
                },
                bench: {
                    4: [],
                    2: [],
                    3: [],
                    1: [],
                },
                excluded: {
                    4: [],
                    2: [],
                    3: [],
                    1: [],
                },
            };
            team.forEach((player) => {
                player._grade = grade_to_pts[player.grade];
                ordered_list["team"][+player.sid].push(player);
            });
            bench.forEach((player) => {
                player._grade = grade_to_pts[player.grade];
                ordered_list["bench"][+player.sid].push(player);
            });
            excluded.forEach((player) => {
                player._grade = grade_to_pts[player.grade];
                ordered_list["excluded"][+player.sid].push(player);
            });

            state.sort_lineup_order.forEach((o) => {
                ordered_list.team[o] = applySort(
                    ordered_list.team[o],
                    "_grade",
                    "desc"
                );
                ordered_list.bench[o] = applySort(
                    ordered_list.bench[o],
                    "_grade",
                    "desc"
                );
                ordered_list.excluded[o] = applySort(
                    ordered_list.excluded[o],
                    "_grade",
                    "desc"
                );
            });

            state.sort_lineup_order.forEach((o) => {
                to_save.team = to_save.team.concat(ordered_list.team[o]);
                to_save.bench = to_save.bench.concat(ordered_list.bench[o]);
                to_save.excluded = to_save.excluded.concat(
                    ordered_list.excluded[o]
                );
            });

            to_save.ub = ub;
            to_save.tb = tb;

            let current_playing_11 = to_save.team.map((player) => player.pid);
            to_save.c_p = prev_playing_11.filter(
                (x) => !current_playing_11.includes(x)
            ).length;

            state.lineup_details = to_save;
        },
        [LOAD_LINEUP_CONFIG]: (state, payload) => {
            state.stg_dropdown = {};
            payload.platforms.forEach((pf_config) => {
                pf_config.strategy.forEach(
                    (strategy) => (strategy.name = strategy.ssn)
                );
                state.stg_dropdown[pf_config.pid] = pf_config.strategy;
            });

            state.pf_dropdowns = payload.platforms.map(({ pid, pname }) => {
                return {
                    pid,
                    pname,
                };
            });
            let first_pf = payload.platforms.find((e) => true);
            let first_stg = first_pf.strategy.find((e) => true);

            let selected_pf, selected_stg;
            if (state.lineup_selection.p_id && state.lineup_selection.s_id) {
                selected_pf = payload.platforms.find(
                    (pf) => pf.pid === state.lineup_selection.p_id
                );
                if (typeof selected_pf !== "undefined") {
                    selected_stg = selected_pf.strategy.find(
                        (st) => st.sid === state.lineup_selection.s_id
                    );
                } else {
                    selected_pf = first_pf;
                    selected_stg = first_stg;
                }
            } else {
                selected_pf = first_pf;
                selected_stg = first_stg;
            }
            state.lineup_selection.p_id = selected_pf.pid;
            state.lineup_selection.s_id = selected_stg.sid;
            state.selected_team.id = selected_stg.teams.find((e) => true);
            state.selected_team.index = 0;
        },
        [RESET_LINEUP]: (state) => {
            state.locked_players = [];
            state.out_players = [];
            state.lineup_details = {
                tb: 0,
                ub: 0,
                team: [],
                bench: [],
                excluded: [],
                c_p: 0,
            };
            state.can_show_players_changed = false;
            state.can_show_undo = false;
        },
        [STORE_PREV_LINEUP]: (state, payload) => {
            if (payload) {
                state.prev_lineup_details = payload;
            } else {
                state.prev_lineup_details = state.lineup_details;
            }
        },
        [SUCCESS_FETCH_ROI_DATA]: (state, payload) => {
            state.contest_loaded = true;
            state.allDataOfTheMatch = payload;
            setRecommendedContestsDataMutation(state);
            if (typeof window === "undefined") state.allDataOfTheMatch = {};
        },
    }
}

export default team_store;